import { render, staticRenderFns } from "./PreguntasMoverAsignaturas.vue?vue&type=template&id=a6e2abce&scoped=true"
import script from "./PreguntasMoverAsignaturas.vue?vue&type=script&lang=js"
export * from "./PreguntasMoverAsignaturas.vue?vue&type=script&lang=js"
import style0 from "./PreguntasMoverAsignaturas.vue?vue&type=style&index=0&id=a6e2abce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e2abce",
  null
  
)

export default component.exports